import React, { createContext, useContext, useState } from 'react';
import FooterModal from '../components/Modals/FooterModal';

enum ModalType {
  SUCCESS = 'success',
  ERROR = 'error',
  INFO = 'info',
}

interface ModalsContextData {
  currentModal: JSX.Element | null;
  showContextModal(type: string, success: boolean, message: string): void;
}

const ModalsContext = createContext<ModalsContextData>({
  currentModal: null,
  showContextModal: () => { },
});

export const ModalsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [currentModal, setCurrentModal] = useState<JSX.Element | null>(null);

  const showContextModal = (type: ModalType, success: boolean, message: string) => {
    setCurrentModal(FooterModal({ success: success, text: message, open: true, onClose: () => { } }));
    setTimeout(() => {
      setCurrentModal(null);
    }, 5000);
  }

  return (
    <ModalsContext.Provider value={{
      currentModal,
      showContextModal,
    }}>
      {children}
    </ModalsContext.Provider>
  );
};

export const useModals = () => {
  return useContext(ModalsContext);
};
